export { default as Badge } from './Badge/index.js';
export { default as P } from './P/index.js';
export { default as Span } from './Span/index.js';
export { default as Small } from './Small/index.js';
export { default as Tiny } from './Tiny/index.js';
export { default as Pre } from './Pre/index.js';
export { default as Code } from './Code/index.js';
//# sourceMappingURL=index.js.map
